import * as React from 'react';
import Avatar from 'antd/lib/avatar';
import Flex from 'antd/lib/flex';
import Segmented, { SegmentedLabeledOption } from 'antd/lib/segmented';
import ConfigProvider from 'antd/lib/config-provider';
import { antGrey } from '../../styles/globalStyles';
import { AppPlatform } from '../../../types';
import { Destination } from '../../../types/destinations';
import { iconForPlatform } from '../../../helpers/platformComponentHelpers';
import WorkflowsPlatformIcon from '../../icons/WorkflowsPlatformIcon';

export const PlatformIconBox: React.FC<{
    platform: AppPlatform;
    size?: number;
    iconSize?: number;
    iconColor?: string;
}> = ({ platform, size = 32, iconSize = 18, iconColor = antGrey.grey6 }) => (
    <Flex
        align="center"
        justify="center"
        style={{
            width: size,
            height: size,
            borderRadius: 6,
            border: `1px dashed ${antGrey.grey7}`,
            flexShrink: 0,
        }}
    >
        {iconForPlatform(platform, iconColor, iconSize)}
    </Flex>
);

export const DestinationIcon: React.FC<{
    destination: Destination;
    size?: number;
}> = ({ destination, size = 16 }) => {
    if (destination.iconURL) {
        return (
            <Avatar
                shape="square"
                size={size}
                src={destination.iconURL}
                style={{
                    borderRadius: size * 0.17,
                    flexShrink: 0,
                }}
            />
        );
    }

    const letter = destination.name?.charAt(0);

    if (letter) {
        return (
            <Avatar
                shape="square"
                size={size}
                style={{
                    borderRadius: size * 0.17,
                    backgroundColor: antGrey.grey7,
                    fontSize: Math.round(size * 0.7),
                    flexShrink: 0,
                }}
            >
                {letter}
            </Avatar>
        );
    }

    return <WorkflowsPlatformIcon platform={destination.platform} width={size} height={size} />;
};

const navigationSegmentedTheme = {
    components: {
        Segmented: {
            trackBg: 'black',
            trackPadding: 4,
            itemColor: antGrey.grey6,
            itemHoverColor: antGrey.grey5,
            itemHoverBg: 'transparent',
            itemSelectedBg: antGrey.grey8,
            itemSelectedColor: antGrey.grey1,
        },
    },
};

export const NavigationSegmented: React.FC<{
    value: string;
    onChange: (value: string | number) => void;
    options: SegmentedLabeledOption[];
}> = ({ value, onChange, options }) => (
    <ConfigProvider theme={navigationSegmentedTheme}>
        <Segmented
            block
            value={value}
            onChange={onChange}
            className="app-menu-segmented"
            style={{ borderRadius: 8 }}
            options={options}
        />
    </ConfigProvider>
);
